interface ListItemsProps {
    type?: 'ul' | 'ol';
    items: string[];
}

// Simple component that takes an array of strings and renders them as a list
export default function ListItems({ type = 'ul', items }: ListItemsProps) {
    const componentClasses = `ml-16`;
    const itemsClasses = `${type === 'ul' ? 'list-disc' : 'list-decimal'}`;
    const ListTag = type;

    return (
        <ListTag className={componentClasses}>
            {items.map((item, index) => (
                <li key={index} className={itemsClasses}>
                    {item}
                </li>
            ))}
        </ListTag>
    );
}
